// src/utils/questionnaireQuestions/r-scale.js
// COPD Assessment Test ()
// Scale: 0 = best • 5 = worst. Sum (0–40).

const RScaleQuestionnaire = [
  /* 1 ─ Cough */
  {
    id: "cough",
    titleKey: "cough.title",
    rangeDescriptionKey: "cough.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 10,
    step: 1,
    // English fallback (kept for safety; UI should prefer i18n string)
    title: "Cough",
    rangeDescription: "0 = None, 10 = Severe",
    group: "R-Scale",
  },

  /* 2 ─ Phlegm */
  {
    id: "shortnessOfBreath",
    titleKey: "shortnessOfBreath.title",
    rangeDescriptionKey: "shortnessOfBreath.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 10,
    step: 1,
    title: "shortnessOfBreath",
    rangeDescription: "0 = None, 10 = Severe",

    group: "R-Scale",
  },

  /* 3 ─ Chest tightness */
  {
    id: "fatigue",
    titleKey: "fatigue.title",
    rangeDescriptionKey: "fatigue.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 10,
    step: 1,
    title: "Fatigue",
    rangeDescription: "0 = None, 10 = Severe",

    group: "R-Scale",
  },

  /* 4 ─ Breathlessness on exertion */
  {
    id: "depressedMood",
    titleKey: "depressedMood.title",
    rangeDescriptionKey: "depressedMood.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 10,
    step: 1,
    title: "Depressed mood",
    rangeDescription: "0 = None, 10 = Severe",

    group: "R-Scale",
  },

  /* 5 ─ Activity limitation at home */
  {
    id: "wellBeing",
    titleKey: "wellBeing.title",
    rangeDescriptionKey: "wellBeing.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 10,
    step: 1,
    title: "Overall sense of wellbeing",
    rangeDescription: "0 = None, 10 = Very Poor",
    group: "R-Scale",
  },
];

export default RScaleQuestionnaire;
